import { render, staticRenderFns } from "./BfDatePicker.vue?vue&type=template&id=0f31a094&"
import script from "./BfDatePicker.vue?vue&type=script&lang=js&"
export * from "./BfDatePicker.vue?vue&type=script&lang=js&"
import style0 from "./BfDatePicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports